export default __webpack_public_path__ + "static/media/6-22-19-bowie.cb078978.m4a";